// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs-component_tabs__wh7wD"};